
var id = "syncMaterial";
var markup = "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"syncMaterial\">\n<path d=\"M6.99998 11.6643C6.99998 11.9356 6.99998 12.157 6.99998 12.3286C6.99998 12.6238 6.99998 13.0667 6.99998 13.6571C6.99998 13.8465 6.85905 14 6.68518 14H1.64813C1.47426 14 1.33331 13.8465 1.33331 13.6571V2.34286C1.33331 2.1535 1.47426 2 1.64813 2H6.68518C6.85905 2 6.99998 2.1535 6.99998 2.34286C6.99998 2.93333 6.99998 3.3762 6.99998 3.67143C6.99998 3.843 6.99998 4.06443 6.99998 4.3357\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"round\" />\n<path d=\"M9 4.3357C9 4.06443 9 3.843 9 3.67143C9 3.3762 9 2.93333 9 2.34286C9 2.1535 9.14093 2 9.3148 2H14.3519C14.5257 2 14.6667 2.1535 14.6667 2.34286V13.6571C14.6667 13.8465 14.5257 14 14.3519 14H9.3148C9.14093 14 9 13.8465 9 13.6571C9 13.0667 9 12.6238 9 12.3286C9 12.157 9 11.9356 9 11.6643\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"round\" />\n<path d=\"M4.16667 12.6667C4.53487 12.6667 4.83333 12.3682 4.83333 12C4.83333 11.6318 4.53487 11.3334 4.16667 11.3334C3.79847 11.3334 3.5 11.6318 3.5 12C3.5 12.3682 3.79847 12.6667 4.16667 12.6667Z\" fill=\"white\" />\n<path d=\"M11.8334 12.6667C12.2016 12.6667 12.5 12.3682 12.5 12C12.5 11.6318 12.2016 11.3334 11.8334 11.3334C11.4652 11.3334 11.1667 11.6318 11.1667 12C11.1667 12.3682 11.4652 12.6667 11.8334 12.6667Z\" fill=\"white\" />\n<path d=\"M5.33331 7.83337H10.6666\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"round\" />\n<path d=\"M9.0744 9.42434L9.60474 8.89404L10.6654 7.83337L9.60474 6.7727L9.0744 6.24237\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
